import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X, ChevronRight } from "lucide-react";

const LoanApplicationFilters = ({
  closeLoanApplicationFilter,
  isLoanApplicationFilterOpen,
  appliedFilters,
  setAppliedFilters,
  loanStatusCodes,
  loanStatusesError,
  isLoadingLoanStatuses,
  selectedFilter,
  setSelectedFilter,
  selectedStatus,
  setSelectedStatus,
  appliedFiltersCount,
  selectedLoanTypes,
  setSelectedLoanTypes,
  selectedDurations,
  setSelectedDurations,
  selectedRepaymentAmounts,
  setSelectedRepaymentAmounts,
}) => {
  const filterMenus = ["Type", "Status", "Duration", "Repayment Amount"];

  const loanTypes = [
    "Flash Loan",
    "Normal Loan",
    "Jijenge Loan",
    "Emergency Loan",
  ];

  const durations = ["< 1 month", "3 – 6 Months", "6–12 Months", "> 12 Months"];

  const repaymentAmounts = [
    "< KES 1,000",
    "KES 1,001 – 10,000",
    "KES 10,001 – 25,000",
    "KES 25,001 – 50,000",
    "KES 50,001 – 100,000",
    "> KES 100,000",
  ];

  const statuses = [
    {
      label: "Incomplete",
      value: "Incomplete_loan_application",
    },
    {
      label: "Pending Review",
      value: "Pending_approval",
    },
    {
      label: "Pending Disbursement",
      value: "Pending_disbursement",
    },
  ];

  const filteredStatuses = statuses?.filter(
    (item) =>
      Array?.isArray(loanStatusCodes) &&
      loanStatusCodes?.some((status) => status?.status_name === item?.value),
  );

  const handleTypeSelection = (type) => {
    const alreadySelected = selectedLoanTypes?.includes(type);

    if (alreadySelected) {
      setSelectedLoanTypes((prev) => prev?.filter((item) => item !== type));
    } else {
      setSelectedLoanTypes((prev) => [...prev, type]);
    }
  };

  const handleDurationSelection = (duration) => {
    const alreadySelected = selectedDurations?.includes(duration);

    if (alreadySelected) {
      setSelectedDurations((prev) => prev?.filter((item) => item !== duration));
    } else {
      setSelectedDurations((prev) => [...prev, duration]);
    }
  };

  const handleRepaymentAmountSelection = (amount) => {
    const alreadySelected = selectedRepaymentAmounts?.includes(amount);

    if (alreadySelected) {
      setSelectedRepaymentAmounts((prev) =>
        prev?.filter((item) => item !== amount),
      );
    } else {
      setSelectedRepaymentAmounts((prev) => [...prev, amount]);
    }
  };

  const renderCheckbox = (isSelected) => (
    <div
      className={`w-[28px] h-[28px] rounded-[6px] border flex items-center justify-center transition-all
      ${
        isSelected
          ? "bg-[#074073] border-[#074073]"
          : "bg-transparent border-[#BDBDBD]"
      }
    `}
    >
      {isSelected && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20 6L9 17L4 12"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  );
  return (
    <SlidePanel
      isOpen={isLoanApplicationFilterOpen}
      onClose={closeLoanApplicationFilter}
    >
      <div className="relative h-full bg-white rounded-[12px] flex flex-col overflow-hidden">
        {/* CLOSE BUTTON */}
        <button
          onClick={closeLoanApplicationFilter}
          className="absolute top-6 right-6 z-20"
        >
          <X size={28} color="#111827" strokeWidth={1.8} />
        </button>

        {/* HEADER */}
        <div className="px-3 md:px-3 pt-6 md:pt-5">
          <h1 className="text-[#111827] text-[28px] font-[700]">Filters</h1>

          <p className="mt-2 text-[#5B5B5B] text-[12px] leading-[24px]">
            Refine your view by selecting specific criteria. Apply filters to
            quickly find the loans you need. You can reset or adjust filters
            anytime.
          </p>
        </div>

        {/* BODY */}
        <div className="flex-1 overflow-hidden mt-4">
          <div className="flex flex-col lg:flex-row h-full">
            {/* LEFT PANEL */}
            <div className="w-[45%] border-r border-[#E5E7EB] px-3 py-4">
              {/* TOP */}
              <div className="flex items-center justify-between mb-5">
                <p className="text-[#000000] text-[20px] font-[600]">Filters</p>

                <div className="h-[38px] px-5 rounded-full bg-[#D8ECFF] flex items-center justify-center">
                  <p className="text-[#111827] text-[14px] font-[400]">
                    {appliedFiltersCount || 0} applied
                  </p>
                </div>
              </div>

              {/* FILTER ITEMS */}
              <div className="flex flex-col gap-4">
                {filterMenus?.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedFilter(item)}
                    className={`w-full rounded-[8px] border px-3 py-3 flex items-center justify-between transition-all
                      ${
                        selectedFilter === item
                          ? "border-[#B8DBFF] shadow-[0_0_0_3px_rgba(216,236,255,0.5)]"
                          : "border-[#D9D9D9]"
                      }
                    `}
                  >
                    <p className="text-[#111827] text-[16px] font-[500]">
                      {item}
                    </p>

                    <ChevronRight size={22} color="#111827" strokeWidth={2} />
                  </button>
                ))}
              </div>
            </div>

            {/* RIGHT PANEL */}
            <div className="flex-1 bg-[#FAFAFA] px-3 md:px-2 py-4 overflow-y-auto">
              {/* TYPE */}
              {selectedFilter === "Type" && (
                <>
                  <h2 className="text-[#000000] text-[20px] font-[500]">
                    Type
                  </h2>

                  <p className="text-[#000000] text-[14px]">
                    Select your loan type type filter
                  </p>

                  <div className="mt-6 flex flex-col gap-6">
                    {loanTypes?.map((type, index) => {
                      const isSelected = selectedLoanTypes?.includes(type);

                      return (
                        <button
                          key={index}
                          onClick={() => handleTypeSelection(type)}
                          className="w-full flex items-center justify-between"
                        >
                          <p className="text-[#000000] text-[16px] font-[400] text-left">
                            {type}
                          </p>

                          {renderCheckbox(isSelected)}
                        </button>
                      );
                    })}
                  </div>
                </>
              )}

              {/* STATUS */}
              {selectedFilter === "Status" && (
                <>
                  <h2 className="text-[#000000] text-[20px] font-[500]">
                    Status
                  </h2>

                  <p className="text-[#000000] text-[14px]">
                    Select your loan application status filter
                  </p>

                  {/* STATUS OPTIONS */}
                  <div className="mt-4 flex flex-col gap-4">
                    {isLoadingLoanStatuses ? (
                      <p className="text-[#6B7280] text-[14px]">
                        Loading loan statuses...
                      </p>
                    ) : loanStatusesError ? (
                      <p className="text-[14px] text-red-500">
                        Failed to load loan statuses
                      </p>
                    ) : filteredStatuses?.length === 0 ? (
                      <p className="text-[#6B7280] text-[14px]">
                        No loan statuses available
                      </p>
                    ) : (
                      filteredStatuses?.map((status, index) => {
                        const isSelected = selectedStatus === status?.value;

                        return (
                          <button
                            key={index}
                            onClick={() => setSelectedStatus(status?.value)}
                            className="w-full flex items-center justify-between"
                          >
                            <p className="text-[#000000] text-[16px] font-[400] text-left">
                              {status?.label}
                            </p>

                            <div
                              className={`w-[25px] h-[25px] rounded-full border flex items-center justify-center transition-all ${isSelected ? "border-[#074073]" : "border-[#A6A6A6]"}`}
                            >
                              {isSelected && (
                                <div className="w-[18px] h-[18px] rounded-full bg-[#074073]" />
                              )}
                            </div>
                          </button>
                        );
                      })
                    )}
                  </div>
                </>
              )}
              {/* DURATION */}
              {selectedFilter === "Duration" && (
                <>
                  <h2 className="text-[#000000] text-[20px] font-[500]">
                    Duration
                  </h2>

                  <p className="text-[#000000] text-[14px]">
                    Select loan application duration range
                  </p>

                  <div className="mt-6 flex flex-col gap-6">
                    {durations?.map((duration, index) => {
                      const isSelected = selectedDurations?.includes(duration);

                      return (
                        <button
                          key={index}
                          onClick={() => handleDurationSelection(duration)}
                          className="w-full flex items-center justify-between"
                        >
                          <p className="text-[#000000] text-[16px] font-[400] text-left">
                            {duration}
                          </p>

                          {renderCheckbox(isSelected)}
                        </button>
                      );
                    })}
                  </div>
                </>
              )}

              {/* REPAYMENT AMOUNT */}
              {selectedFilter === "Repayment Amount" && (
                <>
                  <h2 className="text-[#000000] text-[20px] font-[500]">
                    Amount
                  </h2>

                  <p className="text-[#000000] text-[14px]">
                    Select loan repayment amount range
                  </p>

                  <div className="mt-6 flex flex-col gap-6">
                    {repaymentAmounts?.map((amount, index) => {
                      const isSelected =
                        selectedRepaymentAmounts?.includes(amount);

                      return (
                        <button
                          key={index}
                          onClick={() => handleRepaymentAmountSelection(amount)}
                          className="w-full flex items-center justify-between"
                        >
                          <p className="text-[#000000] text-[16px] font-[400] text-left">
                            {amount}
                          </p>

                          {renderCheckbox(isSelected)}
                        </button>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="border-t border-[#E5E7EB] px-6 py-5 flex flex-col-reverse sm:flex-row items-center justify-end gap-4 bg-white">
          {/* CANCEL */}
          <button
            onClick={closeLoanApplicationFilter}
            className=" rounded-[5px] border border-[#A6A6A6] bg-[#FAFAFA] text-[#060606] py-2 px-4 text-[16px] font-[500]"
          >
            Cancel
          </button>

          {/* APPLY */}
          <button className="rounded-[5px] bg-[#074073] text-white text-[16px] py-2 px-2 font-[500]">
            Apply Filters
          </button>
        </div>
      </div>
    </SlidePanel>
  );
};

export default LoanApplicationFilters;
